import { create } from "zustand";

const useLoaderStore = create((set) => ({
  loading: false,
  setLoading: (loading) => set({ loading }),
}));

export default useLoaderStore;
